import { createReactQueryHooks } from '@trpc/react'
import type { inferProcedureInput } from '@trpc/server'

import type { AppRouter } from 'src/pages/api/trpc/appRouter'

export const trpc = createReactQueryHooks<AppRouter>()

export type TQuery = keyof AppRouter['_def']['queries']

export type InferQueryInput<TRouteKey extends TQuery> = inferProcedureInput<
  AppRouter['_def']['queries'][TRouteKey]
>
